import axios from "axios";
import { APIDomain, APIEndPOints, PostAPIEndPOints } from "./api-config";
import { AuthAPI } from "./auth-api";

export class PricingPortalAPI {
  static getList = async (businessCode, countryCode, serviceName, list, queryParams, email) => {
    try {
      let _curUser = await AuthAPI.validateCurrentUser();
      let _email = email ? email : _curUser.email;
      let token = _curUser.accessToken;
      let API = APIDomain + APIEndPOints[serviceName];
      API = API.replace("<email>", _email);
      API = API.replace("<countryCode>", countryCode);
      API = API.replace("<businessCode>", businessCode);

      if (queryParams) {
        const queryString = Object.entries(queryParams)
          .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
          .join('&');
        if (queryString) {
          if (API.includes('?')) {
            API += `&${queryString}`;
          } else {
            API += `?${queryString}`;
          }
        }
      }

      const response = await axios.get(API, {
        headers: {
          Authorization: "Bearer " + token,
          "x-user-agent": "Rentokil",
        },
      });

      let listData = [];
      if (response.data && response.data[list]) {
        listData = response.data[list];
      } else if (response.data && response.data.response && response.data.response[list]) {
        listData = response.data.response[list];
      }
      // const listData = response.data && response.data[list] ? response.data[list] : [];
      return listData;
    } catch (err) {
      alert(err);
    }
  };

  static getFilterList = async (businessCode, countryCode, serviceName, list, filterClause) => {
    try {
      let _curUser = await AuthAPI.validateCurrentUser();
      let [email, token] = [_curUser.email, _curUser.accessToken];
      let API = APIDomain + APIEndPOints[serviceName] + filterClause;
      API = API.replace("<email>", email);
      API = API.replace("<countryCode>", countryCode);
      API = API.replace("<businessCode>", businessCode);
      const response = await axios.get(API, {
        headers: {
          Authorization: "Bearer " + token,
          "x-user-agent": "Rentokil",
        },
      });

      let listData = [];
      if (response.data && response.data[list]) {
        listData = response.data[list];
      } else if (response.data && response.data.response && response.data.response[list]) {
        listData = response.data.response[list];
      }
      // const listData = response.data && response.data[list] ? response.data[list] : [];
      return listData;
    } catch (err) {
      alert(err);
    }
  };

  static updateList = async (serviceName, postBody) => {
    try {
      let _curUser = await AuthAPI.validateCurrentUser();
      let token = _curUser.accessToken;
      const API = APIDomain + PostAPIEndPOints[serviceName];

      const response = await axios.post(API, postBody, {
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
          "x-user-agent": "Rentokil",
        },
      });

      if (response.data && response.data.response && response.data.response.errorNumber) {
        response.data.errorNumber = response.data.response.errorNumber;
        response.data.errorDescription = response.data.response.errorDescription;
      }

      return response;
    } catch (err) {
      alert(err);
    }
  };

  static getListWithPagination = async (businessCode, countryCode, serviceName, list, filterClause, page = 0) => {
    let allListData = [];
    try {
      let _curUser = await AuthAPI.validateCurrentUser();
      let [email, token] = [_curUser.email, _curUser.accessToken];
      let API = filterClause ? APIDomain + APIEndPOints[serviceName] + filterClause : APIDomain + APIEndPOints[serviceName];
      API = API.replace("<email>", email);
      API = API.replace("<countryCode>", countryCode);
      API = API.replace("<businessCode>", businessCode);

      // Fetch first page
      let response = await axios.get(API + `&pageIndex=${page}`, {
        headers: {
          Authorization: "Bearer " + token,
          "x-user-agent": "Rentokil",
        },
      });

      // Process first page data
      const listData = response.data && response.data[list] ? response.data[list] : { list: "" };
      allListData = [...allListData, ...listData];

      // Check for more records
      while (response.data.hasMoreRecords) {
        page++;

        // Fetch next page
        response = await axios.get(API + `&pageIndex=${page}`, {
          headers: { Authorization: "Bearer " + token, "x-user-agent": "Rentokil" },
        });

        // Process next page data
        const nextPageListData = response.data && response.data[list] ? response.data[list] : { list: "" };

        // Append next page data to the list
        allListData = [...allListData, ...nextPageListData];
      }

      return allListData;
    } catch (err) {
      alert(err);
    }
  };
}
